import * as types from "./actionTypes"

const initialState = {
    display: false,
}

export default function loaderReducer(state = initialState, action) {
    switch (action.type) {
        case types.SET_LOADER:
            return {
                ...state,
                display: action.payload,
            }

        default:
            return state
    }
}
